import { CTA_BUTTON_CLICKED, TOUR_STARTED } from 'aria-viewer/modal/constants/ModalSources'

// Desktop Experience
export const EXP_EXPSELECTED = 'Exp_ExpSelected'
export const EXP_LOADED = 'Exp_Loaded'
export const EXP_STOP_LOADED = 'Exp_Stop_Loaded'
export const EXP_STOP_LOADED_MAX_EVENTS_SENT = 2
export const EXP_10_SECOND_MARK = 'Exp_10_Second_Mark'
export const EXP_CTABUTTON_CLICKED = 'Exp_CTAButton_Clicked'
export const EXP_REGISTRATION_KEYBOARD_PRESSED = 'Exp_Registration_Keyboard_Pressed'
export const EXP_KEYBOARD_PRESSED = 'Exp_Keyboard_Pressed'
export const EXP_SUPP_MEDIA_CLICKED = 'Exp_Supp_Media_Clicked'
export const EXP_LANGUAGE_ICON_CLICKED = 'Exp_Language_Icon_Clicked'
export const EXP_LANGUAGE_SELECTED = 'Exp_Language_Selected'

export const EXP_ADA_MODE = 'Exp_ADA_MODE'

// Registration
export const EXP_REGAVAILABLE = 'Exp_RegAvailable'
export const EXP_REG_VIEWED = 'Exp_Reg_Viewed'
export const EXP_REG_CLOSED = 'Exp_Reg_Closed'
export const EXP_REG_FINISHBUTTON_CLICKED = 'Exp_Reg_FinishedButton_Clicked'
export const EXP_REG_SUCCESS_VIEWED = 'Exp_Reg_Success_Viewed'
export const EXP_REG_DONEBUTTON_CLICKED = 'Exp_Reg_DoneButton_Clicked'
export const INIT_BY = {
    [TOUR_STARTED]: 'Automated',
    [CTA_BUTTON_CLICKED]: 'CTA Button',
}

// CTA Prompt Now
export const EXP_ACTNOW_VIEWED = 'Exp_ActNow_Viewed'

// Payments
export const EXP_SCENEPAY_AVAILABLE = 'Exp_ScenePay_Available'
export const EXP_SCENEPAY_HOVER_VIEWED = 'Exp_ScenePay_Hover_Viewed'
export const EXP_SCENEPAY_BUTTON_CLICKED = 'Exp_ScenePay_Button_Clicked'
export const EXP_ITEMDET_POPUP_VIEWED = 'Exp_ItemDet_PopUp_Viewed'
export const EXP_ITEMDET_POPUP_CLOSED = 'Exp_ItemDet_Popup_Closed'
export const EXP_ITEMDET_BUY_CLICKED = 'Exp_ItemDet_Buy_Clicked'
export const EXP_ITEMDET_FACEBOOK_CLICKED = 'Exp_ItemDet_Facebook_Clicked'
export const EXP_ITEMDET_GOOGLE_CLICKED = 'Exp_ItemDet_Google_Clicked'
export const EXP_ITEMDET_GUEST_CLICKED = 'Exp_ItemDet_Guest_Clicked'
export const EXP_ITEMDET_EXPRESSCHECKOUT_VIEWED = 'Exp_ItemDet_ExpressCheckout_Viewed'
export const EXP_ITEMDET_EXPRESSCHECKOUT_CLICKED = 'Exp_ItemDet_ExpressCheckout_Clicked'
export const EXP_SHIPDETS_VIEWED = 'Exp_ShipDets_Viewed'
export const EXP_SHIPDETS_SUBMIT = 'Exp_ShipDets_Submit'
export const EXP_SHIPDETS_SUBMIT_ERROR = 'Exp_ShipDets_Submit_Error'
export const EXP_SHIPDETS_CLOSED = 'Exp_ShipDets_Closed'
export const EXP_PAYMETH_VIEWED = 'Exp_PayMeth_Viewed'
export const EXP_PAYMETH_CLOSED = 'Exp_PayMeth_Closed'
export const EXP_PAYMETH_SUBMIT = 'Exp_PayMeth_Submit'
export const EXP_PAYMETH_SUBMIT_ERROR = 'Exp_PayMeth_Submit_Error'
export const EXP_ORDDETS_VIEWED = 'Exp_OrdDets_Viewed'
export const EXP_ORDDETS_PLACEORDER_CLICKED = 'Exp_OrdDets_PlaceOrder_Clicked'
export const EXP_ORDDETS_PLACEORDER_ERROR = 'Exp_OrdDets_PlaceOrder_Error'
export const EXP_ORDDETS_PLACEORDER_SUCCESS = 'Exp_OrdDets_PlaceOrder_Success'
export const EXP_ORDDETS_CLOSED = 'Exp_OrdDets_Closed'
export const EXP_ITEMPURCHASED_VIEWED = 'Exp_ItemPurchased_Viewed'
export const EXP_ITEMPURCHASED_CLOSED = 'Exp_ItemPurchased_Closed'
export const EXP_ITEMPURCHASED_CONTINUE = 'Exp_ItemPurchased_Continue'

export const MOREICON_CLICKED = 'MoreIcon_Clicked'
export const MOREICON_FULLSCREEN_CLICKED = 'MoreIcon_FullScreen_Clicked'
export const MOREICON_VIEWINVR_CLICKED = 'MoreIcon_ViewinVR_Clicked'

export const SHARE_CLICKED = 'Share_Clicked'
export const SHARE_FACEBOOK_CLICKED = 'Share_Facebook_Clicked'
export const SHARE_TWITTER_CLICKED = 'Share_Twitter_Clicked'
export const SHARE_EMAIL_CLICKED = 'Share_Email_Clicked'
export const SHARE_LINKEDIN_CLICKED = 'Share_LinkedIn_Clicked'
export const SHARE_LINK_CLICKED = 'Share_Link_Clicked'
